import type { TFunction } from 'i18next';

export type WizardCaseType =
  | 'criminal'
  | 'criminalAppellate'
  | 'civilLitigation'
  | 'civilAppellate'
  | 'civilAdvise'
  | 'attorneyGeneral'
  | 'extraditionMla'
  | 'nomination'
  | 'publicPetition'
  | 'rightToInformation';

export function wizardStepBarLabel(t: TFunction, n: number): string {
  return t('wizard.stepBarLabel', { num: String(n).padStart(2, '0') });
}

export function wizardReviewStepLabel(t: TFunction, n: number): string {
  return t('wizard.reviewStepLabel', { num: String(n).padStart(2, '0') });
}

export function wizardStepTitle(t: TFunction, caseType: WizardCaseType, n: number): string {
  return t(`wizard.${caseType}.steps.${n}`);
}

export function wizardStepTitleLines(
  t: TFunction,
  caseType: WizardCaseType,
  n: number,
): readonly [string, string] | undefined {
  const val = t(`wizard.${caseType}.stepLines.${n}`, { defaultValue: '' });
  if (!val) return undefined;
  const parts = val.split('\n');
  if (parts.length >= 2) return [parts[0]!, parts[1]!] as const;
  return undefined;
}

export function wizardYesNo(t: TFunction, v: string): string {
  if (v === 'yes') return t('common.yes');
  if (v === 'no') return t('common.no');
  return '—';
}

export function wizardField(t: TFunction, key: string): string {
  return t(`wizard.fields.${key}`);
}

export function wizardSection(t: TFunction, key: string): string {
  return t(`wizard.sections.${key}`);
}

export function wizardInstituteTypeLabel(
  t: TFunction,
  instituteType: string,
  corporateDisplay?: string,
): string {
  if (instituteType === 'corporation') {
    return corporateDisplay?.trim() || t('wizard.fields.corporation');
  }
  if (instituteType === 'government') return t('wizard.fields.governmentDepartment');
  return '—';
}

export function wizardPartyBodyTypeLabel(t: TFunction, v: string, alt = false): string {
  if (v === 'government' || v === 'unincorporated') {
    return alt
      ? t('wizard.fields.governmentMinistryDepartmentAlt')
      : t('wizard.fields.governmentMinistryDepartment');
  }
  if (v === 'incorporated' || v === 'corporation') {
    return alt
      ? t('wizard.fields.publicCorporationStatutoryAlt')
      : t('wizard.fields.publicCorporationStatutory');
  }
  return '—';
}

export function wizardCaseMatterLabel(t: TFunction, v: string): string {
  if (v === 'CRIMINAL') return t('wizard.fields.criminalMatter');
  if (v === 'CIVIL') return t('wizard.fields.civilMatter');
  return '—';
}
